import { PageControl } from './main';

export class Supplier {
  citiesActuated: Array<any> = [];
  city: string;
  contactEmail: string;
  contactName: string;
  continent: string;
  country: string;
  description: string = '';
  email: string;
  employeeNumber: string;
  employeeQuantity: string;
  expertise: string;
  firaId: number;
  foundationYear: string;
  id: string;
  imageUrl: string;
  name: string;
  phone: string;
  region: string;
  relatedSuppliers: Array<any> = [];
  solution: Array<any> = [];
  supplierId: string;
  type: string;
  website: string;
  countryCode: string;
  skype: string;
}

export interface IExcel {
  description: string,
  file: {
    absolute: boolean,
    absoluteFile: {},
    absolutePath: string,
    canonicalFile: {},
    canonicalPath: string,
    directory: boolean,
    executable: boolean,
    file: boolean,
    freeSpace: number,
    hidden: boolean,
    lastModified: number,
    name: string,
    parent: string,
    parentFile: {},
    path: string,
    readable: boolean,
    totalSpace: number,
    usableSpace: number,
    writable: boolean
  },
  filename: string,
  inputStream: {},
  open: boolean,
  readable: boolean,
  uri: {
    absolute: boolean,
    authority: string,
    fragment: string,
    host: string,
    opaque: boolean,
    path: string,
    port: number,
    query: string,
    rawAuthority: string,
    rawFragment: string,
    rawPath: string,
    rawQuery: string,
    rawSchemeSpecificPart: string,
    rawUserInfo: string,
    scheme: string,
    schemeSpecificPart: string,
    userInfo: string
  },
  url: {
    authority: string,
    content: {},
    defaultPort: number,
    deserializedFields: {},
    file: string,
    host: string,
    path: string,
    port: number,
    protocol: string,
    query: string,
    ref: string,
    serializedHashCode: number,
    userInfo: string
  }
}

export class SupplierModel {
  id: string;
  name: string;
  type: string;
  city: string;
  phone: string;
  email: string;
  region: string;
  country: string;
  website: string;
  imageUrl: string;
  expertise: string;
  continent: string;
  contactName: string;
  description: string = '';
  contactEmail: string;
  employeeNumber: string;
  firaId: number;
  foundationYear: number;
  employeeQuantity: string;
  countryCode: string;
  availablePlaces: string[];
  skype: string;
}

export class SupplierSalesContact {
  name: string;
  email: string;
  completePhone: string;
  phoneCode: string;
  phoneNumber: string;
}

export class SuppliersSearchParams {
  featuredIn: string[] = [];
  location: string[] = [];
  technology: string[] = [];
  findSupplier: string;
  pageControl: PageControl = new PageControl;
}

export class OpportunitiesSearchParams extends PageControl {
  query: string;
  solutionId: string;
  country: string;
  regions: string[];
  populationRanges: string[];

}

export class CitiesSuppliersHelper {
  supplierId: string;
  name: string;
  city: string;
  country: string;
  description: string;
  imageUrl: string;
}
